export default __webpack_public_path__ + "static/all-buttons-dark-b08339320a1597d7769513f1bf7fd026.png";